import { render, staticRenderFns } from "./RepuAgencySideBar.vue?vue&type=template&id=2277649a"
import script from "./RepuAgencySideBar.vue?vue&type=script&lang=js"
export * from "./RepuAgencySideBar.vue?vue&type=script&lang=js"
import style0 from "./RepuAgencySideBar.vue?vue&type=style&index=0&id=2277649a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports